/*
 * @TagDialog.vue.vue  SIM卡配置
 * @Description
 * @Author CC
 * @Date 2025/09/20
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" custom-class="form-dialog forms-box" v-dialogDrag class="dialog_title" @close="handleDialogClose">
		<el-form label-width="110px" class="condition-form-item" ref="configForm" :rules="rules" :model="configForm">
            <el-form-item class="row-items-1" label="消息内容：" prop="content">
                <el-input type="textarea" :rows="5" v-model="configForm.content" />
            </el-form-item>
            <el-form-item class="row-items-1 btn-form-item-r" style="text-align: right;padding-top: 10px;">
                <el-button type="primary" size="mini" @click.native="save">保存消息</el-button>
            </el-form-item>
		</el-form>

	</el-dialog>
</template>

<script>
	// SIM信息 组件
	import ApiNotice from '../../request/api-notice'

	export default {
		/**
		 * @Des 组件名
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		name: "GpsTagNoticeAddDialog",
		/**
		 * @Des 组件引用
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		components: {},
		props: {},
		/**
		 * @Des 数据定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		data() {
			return {
				// 弹出层属性
				dialogForm: {
					title: "",
					dialogFormVisible: false,
				},
				/**
				 * @Des 标签属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				configForm: {
                    // 编号
                    dids: [],
                    // 消息内容
					content: '',
				},
				index: -1,
				/**
				 * @Des 规则属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				rules: {
                    content: [
                        { required: true, message: '请输入消息内容', trigger: 'blur' }
                    ]
				}
			}
		},
		created() {},
		mounted() {},
		/**
		 * @Des 方法定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		methods: {
			/**
			 * @Des 打开弹出层
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			openDialog(data) {
                // 赋值
                this.setData(data);
				// console.log(data);
				this.dialogForm.title = '添加消息';
				this.dialogForm.dialogFormVisible = true;
			},


			/**
			 * 设置值
			 * */
			setData(data) {
				this.configForm = Object.assign({}, this.configForm, data);
            },

			/**
			 * 保存消息
			 * */
			save() {
			    if(this.configForm.dids.length == 0){
                    this.$message({
                        message: '未找到要保存消息的设备id',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return;
                }
                let params = {
                    dids: this.configForm.dids,
                    content: this.configForm.content
                }
                this.loading = this.$loading({
                    lock: true,
                    text: '正在添加消息...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$request.postJsonRequest(ApiNotice.addNoticeApi, params).then(result => {
                    this.loading.close();
                    if(result.code == 0) {
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$emit("searchGpsTag");
                        this.handleDialogClose();
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.log("保存设备消息异常：" + this.$request.error.msg);
                    this.loading.close();
                })
			},

			/**
			 * @Des 弹窗关闭
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleDialogClose() {
				this.reset();
			},
			/**
			 * @Des 重置
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			reset() {
                this.cleanData();
                this.cleanValidate('configForm');
                this.dialogForm.dialogFormVisible = false;
            },

			/**
			 * @Des 清除表单验证
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanValidate(formName) {
				// 清除表单校验的提示
				if(this.$refs[formName]) {
					// 延时执行
					this.$nextTick(function() {
						this.$refs[formName].clearValidate();
					})
				};
			},
			/**
			 * @Des 清除数据
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanData() {
				// 将数据置为空
				this.configForm = Object.assign({
					// 编号
					dids: [],
				}, {});
			},
		}
	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 800px;
	}

	/deep/ .condition-form-item .el-form-item__label {
		line-height: 30px;
	}

	/deep/ .condition-form-item .el-form-item__content {
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagNoticeAddDialog.vue